import jsdk from '../../jsdk';

// restituisce un array con gli elementi mischiati a caso
export default function shuffle(xs) {
  var random = function(a, b) {
    return (Math.random() * (b - 1)) + a;
  };
  var random_integer = function(a, b) {
    return parseInt(random(a, b), 10);
  };
  xs = xs.slice();
  var ys = [];
  var i;
  while (xs.length) {
    i = random_integer(0, xs.length - 1);
    ys.push(xs[i]);
    xs = jsdk.remove(xs, i);
  }
  return ys;
}



/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/util/shuffle.js
 **/